// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__27wfr","title":"InfoRow_title__3cy3V"};